import { X } from 'lucide-react'
import type { PropsWithChildren } from 'react'
import { toast } from 'sonner'
import { cn } from '@/lib/utils'

const variants = {
  alert: {
    header: 'border-blue-600'
  },
  error: {
    header: 'border-destructive'
  }
}

type variantTypes = keyof typeof variants

interface ToastContentProps extends PropsWithChildren {
  className?: string
  toastId: string | number
  variant?: variantTypes
}

export function ToastContent({
  className,
  toastId,
  children,
  variant = 'alert'
}: ToastContentProps) {
  function closeToast() {
    toast.dismiss(toastId)
  }

  return (
    <div
      className={cn(
        'w-100 h-full bg-background flex justify-between rounded-lg border border-t-6 border-background overflow-hidden p-2',
        variants[variant].header,
        className
      )}
    >
      <div className="w-full p-2 flex justify-between gap-3 bg-transparent items-start">
        <div className="w-full">{children}</div>
        <button onClick={closeToast} type="button" className="cursor-pointer">
          <X size={16} className="text-foreground/50" />
        </button>
      </div>
    </div>
  )
}
